document.addEventListener('DOMContentLoaded', function () {
  var textEl = document.querySelector('.announcement-bar__text');
  if (!textEl) return;

  var slide = textEl.closest('.announcement-bar__slide');
  if (!slide || slide.querySelector('.announcement-bar__marquee-track')) return;

  var text = textEl.textContent.trim();
  if (!text) return;

  var track = document.createElement('div');
  track.className = 'announcement-bar__marquee-track';

  var group = document.createElement('div');
  group.className = 'announcement-bar__marquee-group';

  for (var i = 0; i < 2; i++) {
    var span = document.createElement('span');
    span.className = 'announcement-bar__text';
    span.textContent = text;
    group.appendChild(span);
  }

  track.appendChild(group);
  textEl.replaceWith(track);
});

(function () {
  var loader = document.getElementById('cm-page-loader');
  if (!loader) return;

  var hidden = false;
  function hideLoader() {
    if (hidden) return;
    hidden = true;
    loader.classList.add('cm-page-loader--hidden');
    window.setTimeout(function () {
      loader.remove();
    }, 400);
  }

  if (document.readyState === 'complete') {
    hideLoader();
  } else {
    window.addEventListener('load', hideLoader);
  }
  window.setTimeout(hideLoader, 4000);
})();

// Compte a rebours precommande (jours / heures / minutes, sans les secondes).
// Le texte de la date reste toujours affiche en HTML pur (SEO) ; ce script ne fait
// qu'ajouter les chiffres du decompte, mis a jour chaque minute.
(function () {
  var cards = document.querySelectorAll('[data-countdown-target]');
  if (!cards.length) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick(card) {
    var target = new Date(card.getAttribute('data-countdown-target')).getTime();
    var now = Date.now();
    var diff = target - now;

    var daysEl = card.querySelector('[data-days]');
    var hoursEl = card.querySelector('[data-hours]');
    var minutesEl = card.querySelector('[data-minutes]');

    if (diff <= 0) {
      var output = card.querySelector('[data-countdown-output]');
      if (output) output.remove();
      return false;
    }

    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    var minutes = Math.floor((diff / (1000 * 60)) % 60);

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    return true;
  }

  cards.forEach(function (card) {
    if (!tick(card)) return;
    var interval = setInterval(function () {
      if (!tick(card)) clearInterval(interval);
    }, 30000);
  });
})();

// Stock faible : met a jour "Il n'en reste plus que X en stock" quand on change de taille/variante.
(function () {
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('input[type="radio"][data-variant-id]')) return;

    var mapScript = document.querySelector('[data-variant-inventory-map]');
    var output = document.querySelector('[data-low-stock-output]');
    if (!mapScript || !output) return;

    var map;
    try {
      map = JSON.parse(mapScript.textContent);
    } catch (err) {
      return;
    }

    var qty = map[input.dataset.variantId];
    if (qty !== null && qty !== undefined && qty > 0 && qty <= 10) {
      output.textContent = "Il n'en reste plus que " + qty + ' en stock';
      output.hidden = false;
    } else {
      output.hidden = true;
      output.textContent = '';
    }
  });
})();

// FAQ : ouvre la question ciblee par l'ancre de l'URL (ex. /pages/faq#delais-livraison).
(function () {
  function openFromHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (el && el.tagName === 'DETAILS' && el.closest('.cm-faq')) {
      el.open = true;
      el.scrollIntoView({ block: 'start' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
  window.addEventListener('hashchange', openFromHash);
})();

// Textes a harmoniser sans modifier les gros fichiers du theme (page Contact, texte de livraison des fiches) :
// delai de 30 jours "a compter de la reception" partout, et "apres l'expedition" pour les 3 a 5 jours.
(function () {
  var REPLACEMENTS = [
    ['dans les 14 jours suivant la livraison', 'dans les 30 jours suivant la réception de votre commande'],
    ['Vous disposez de 30 jours.', 'Vous disposez de 30 jours à compter de la réception de votre commande.'],
    [
      'Comptez en moyenne 3 à 5 jours ouvrés pour recevoir votre colis.',
      'Comptez en moyenne 3 à 5 jours ouvrés après l’expédition pour recevoir votre colis.',
    ],
  ];

  function fixTexts() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(parent.nodeName)) continue;
      var before = node.nodeValue;
      var after = before;
      for (var i = 0; i < REPLACEMENTS.length; i++) {
        if (after.indexOf(REPLACEMENTS[i][0]) !== -1) after = after.split(REPLACEMENTS[i][0]).join(REPLACEMENTS[i][1]);
      }
      if (after !== before) node.nodeValue = after;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixTexts);
  } else {
    fixTexts();
  }
  window.addEventListener('load', fixTexts);
})();

// Precommande (fiche produit) : selon la variante choisie, affiche ou masque le message
// "Livraison prevue sous 2 semaines" et garde les boutons de paiement rapide (dont Apple Pay) caches
// pour une variante en precommande. L'etat de chaque variante vient du HTML ([data-variant-preorder-map]).
// Le theme reaffiche les boutons rapides a chaque changement de variante : on les recache ici.
// Attention : c'est de l'affichage uniquement, ce n'est pas un blocage du paiement.
(function () {
  function syncBlock(block) {
    var idInput = block.querySelector('input[name="id"]');
    var mapEl = block.querySelector('[data-variant-preorder-map]');
    if (!idInput || !mapEl) return;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (err) {
      return;
    }

    var state = map[idInput.value] || '';

    var note = block.querySelector('[data-preorder-note]');
    if (note) {
      var showNote = state === '2w';
      if (note.hidden === showNote) note.hidden = !showNote;
    }

    if (state) {
      block.querySelectorAll('.accelerated-checkout-block').forEach(function (el) {
        if (!el.hidden) el.hidden = true;
      });
    }
  }

  function syncAll() {
    document.querySelectorAll('.buy-buttons-block').forEach(syncBlock);
  }

  function isRelevant(mutation) {
    var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (target && target.closest && target.closest('.buy-buttons-block')) return true;
    for (var i = 0; i < mutation.addedNodes.length; i++) {
      var node = mutation.addedNodes[i];
      if (node.nodeType === 1 && (node.matches('.buy-buttons-block') || node.querySelector('.buy-buttons-block'))) {
        return true;
      }
    }
    return false;
  }

  function start() {
    syncAll();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (isRelevant(mutations[i])) {
          syncAll();
          return;
        }
      }
    }).observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'disabled'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// Precommande dans le tunnel de paiement : pour une variante en precommande, on ajoute au panier une
// propriete visible "Précommande". Shopify l'affiche sous l'article dans le paiement, dans la commande (admin)
// et dans les e-mails (line.properties). Elle est retiree si la variante choisie n'est plus en precommande.
// Marche sur la fiche produit ([data-variant-preorder-map]) ET dans la fenetre "Choisir" des cartes produits
// (etat lu sur la carte : [data-cm-card-preorder-map], ecrit par snippets/quick-add.liquid).
// Texte de la date : celui du produit (metachamp custom.preorder_ship_date), sinon 15 novembre 2026.
(function () {
  var PROP_NAME = 'properties[Précommande]';
  var TEXT_2W = 'Livraison prévue sous 2 semaines à compter de ta commande';
  var TEXT_DATED_DEFAULT = 'Expédition à partir du 15 novembre 2026';

  // Textes du panier : un seul colis, on attend le reassort de l'article manquant.
  var CART_MIXED =
    "Ton panier contient des articles disponibles et des précommandes. Pour t'éviter plusieurs colis, on attend le réassort de l'article manquant avant de t'envoyer l'ensemble de ta commande en un seul colis.";
  var CART_ONLY_PRE =
    "Ton panier contient des articles en précommande. La date d'expédition est indiquée sous chaque article.";
  var CART_LINE = "Expédié avec le reste de ta commande, en un seul colis, dès que tout est prêt.";

  function findMap(pfc) {
    var block = pfc.closest('.buy-buttons-block');
    var el = block && block.querySelector('[data-variant-preorder-map]');
    if (el) return el;
    el = pfc.querySelector('[data-cm-card-preorder-map]');
    if (el) return el;
    var pid = pfc.getAttribute('data-product-id');
    if (!pid) return null;
    return document.querySelector(
      '.quick-add__product-form-component[data-product-id="' + pid + '"] [data-cm-card-preorder-map]'
    );
  }

  function datedText(mapEl) {
    var fromMap = mapEl.getAttribute('data-dated-text');
    if (fromMap) return fromMap;
    var mods = document.querySelector('[data-cm-ship-text]');
    return (mods && mods.getAttribute('data-cm-ship-text')) || TEXT_DATED_DEFAULT;
  }

  function syncProp(pfc) {
    var form = pfc.querySelector('form.shopify-product-form') || pfc.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var mapEl = findMap(pfc);
    if (!idInput || !mapEl) return;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (err) {
      return;
    }

    var state = map[idInput.value] || '';
    var text = state === '2w' ? TEXT_2W : state === 'dated' ? datedText(mapEl) : '';
    var prop = form.querySelector('input[data-cm-preorder-prop]');

    if (!text) {
      if (prop) prop.remove();
      return;
    }
    if (!prop) {
      prop = document.createElement('input');
      prop.type = 'hidden';
      prop.name = PROP_NAME;
      prop.setAttribute('data-cm-preorder-prop', '');
      form.appendChild(prop);
    }
    if (prop.value !== text) prop.value = text;
  }

  function syncAllProps() {
    document.querySelectorAll('product-form-component').forEach(syncProp);
  }

  // Panier : la ligne "Précommande" est deja affichee par l'etiquette rose, on masque la propriete en double.
  function hideCartDuplicate() {
    document.querySelectorAll('.cart-items__property').forEach(function (el) {
      var dt = el.querySelector('dt');
      if (dt && dt.textContent.trim().indexOf('Précommande') === 0) {
        el.style.display = 'none';
        var list = el.closest('.cart-items__properties');
        if (list) {
          var visible = Array.prototype.some.call(list.querySelectorAll('.cart-items__property'), function (p) {
            return p.style.display !== 'none';
          });
          if (!visible) list.style.display = 'none';
        }
      }
    });
  }

  // Panier : remplace les anciens avis ("livrés plus tard", "2 colis") par le message "un seul colis",
  // et affiche sous chaque precommande datee sa date d'expedition (lue dans la propriete de la ligne).
  function fixCartNotices() {
    var rows = document.querySelectorAll('.cart-items__table-row').length;
    var preTags = document.querySelectorAll('.cm-cart-preorder-tag').length;
    var mixed = preTags > 0 && rows > preTags;

    document.querySelectorAll('.cm-split-shipment-notice').forEach(function (el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.cm-preorder-cart-notice').forEach(function (el) {
      var text = mixed ? CART_MIXED : CART_ONLY_PRE;
      if (el.textContent.trim() !== text) el.textContent = text;
    });
    document.querySelectorAll('.cm-cart-preorder-text').forEach(function (el) {
      var isOld = el.textContent.indexOf('plus tard que les articles en stock') !== -1;
      if (!isOld && !el.hasAttribute('data-cm-fixed')) return;
      var row = el.closest('.cart-items__table-row');
      var dd = row && row.querySelector('.cart-items__property dd');
      var when = dd ? dd.textContent.replace(/\s+/g, ' ').trim() : '';
      var text = when ? when + ' : expédié avec le reste de ta commande, en un seul colis.' : CART_LINE;
      if (el.textContent.trim() !== text) el.textContent = text;
      el.setAttribute('data-cm-fixed', '');
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      syncAllProps();
      hideCartDuplicate();
      fixCartNotices();
    }, 30);
  }

  function start() {
    schedule();
    new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true });
    document.addEventListener('change', schedule);
    document.addEventListener('click', function () {
      window.setTimeout(schedule, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();